import { render, staticRenderFns } from "./AddressPopup.vue?vue&type=template&id=3133252c&scoped=true&"
import script from "./AddressPopup.vue?vue&type=script&lang=js&"
export * from "./AddressPopup.vue?vue&type=script&lang=js&"
import style0 from "./AddressPopup.vue?vue&type=style&index=0&id=3133252c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3133252c",
  null
  
)

export default component.exports